import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'medpt-body',
    templateUrl: './body.component.html',
    styleUrls: ['./body.component.scss'],
    standalone: false
})
export class BodyComponent implements OnInit {
  @Input() isRaiLayout: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

}
